module.exports = __webpack_public_path__ + "flag.svg?b868d851116fd8ecd2f2b9c83b44115c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/flag.svg
// module id = 163
// module chunks = 0